import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "previewBody"]
  static values = { summary: String }

  insertSummary() {
    if (!this.summaryValue) return
    this.bodyTarget.value += this.summaryValue
    if (this.hasPreviewBodyTarget) this.previewBodyTarget.textContent = this.bodyTarget.value
  }
}
